// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { polygonAmoy as _polygonAmoy } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the polygonAmoy chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 80002
 * Chain Name: Polygon Amoy
 * Default Block Explorer: https://amoy.polygonscan.com
 * Default RPC URL: https://rpc-amoy.polygon.technology
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { polygonAmoy } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: polygonAmoy,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const polygonAmoy = createCommon({
	..._polygonAmoy,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
